import { Component, OnInit, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {
  BackendUploadService,
  ItemProvider,
  NotificationService
} from '@ntap/core';
import { ContentDownloadService } from './preuzmi-datoteku-dokument.service';
import { PrimeNGButtonDocDownloadActionComponent } from '@ntap/primeng';
import { isDatoteka } from '@app/shared/models/datoteka';

@Component({
  selector: 'app-download-action',
  templateUrl: './preuzmi-datoteku-dokument.component.html'
})
export class DownloadActionComponent
  extends PrimeNGButtonDocDownloadActionComponent
  implements OnInit
{
  enabled$: Observable<boolean>;

  constructor(
    protected override notificationService: NotificationService,
    protected override backendUploadService: BackendUploadService,
    @Optional() protected override itemProvider: ItemProvider,
    protected contentDownloadService: ContentDownloadService
  ) {
    super(notificationService, backendUploadService, itemProvider);
  }

  ngOnInit(): void {
    this.initDisabledObservable();
  }

  override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider?.item$.pipe(
      take(1),
      map((item) => {
        return isDatoteka(item) ? item['en~datoteka~rezidualni_podaci'] : true;
      })
    );
  }

  override executeAction(): void {
    this.itemProvider?.item$.pipe(take(1)).subscribe((item: any) => {
      if (item) {
        const objectType = item['$itemType'];
        const objectId = item['en~datoteka~id'];
        const renditionName = 'default';
        const isFolder = item['en~datoteka~is_directory'] === true;

        const download$ = isFolder
          ? this.contentDownloadService.downloadFolder(
              objectType,
              objectId,
              renditionName
            )
          : this.contentDownloadService.downloadFile(
              objectType,
              objectId,
              renditionName
            );

        download$.subscribe({
          next: () => {
            this.notificationService.success('Preuzimanje je završeno.');
          },
          error: (error) => {
            const errorMessage = this.getErrorMessage(error);
            this.notificationService.error(
              'Greška kod prezimanja datoteke: ' + errorMessage
            );
          }
        });
      }
    });
  }

  protected getErrorMessage(error: any): string {
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      return error.error.message;
    } else {
      // Server-side error
      return `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
  }
}
